// src/pages/NeurologicalTesting.jsx
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Widgets from '../components/WidgetTiles';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


const NeurologicalTesting = () => (
    <>
        <Header />
        <div id="content" role="main" className="home">
            {/* Interior Header */}
            <div id="interior-header-container" className="container-fluid">
                <div className="container">
                    <h1>ADHD Testing</h1>
                </div>
            </div>

            {/* Content Sections */}
            <div className="container py-5">
                {/* ADHD Testing */}
                <div className="row align-items-center mb-5">
                    <div className="col-md-6">
                        <LazyLoadImage
                            src="/img/adhd-testing.jpg"
                            alt="ADHD Testing"
                            className="img-fluid"
                            style={{
                                WebkitTransform: 'scaleX(-1)',
                                MozTransform: 'scaleX(-1)',
                                OTransform: 'scaleX(-1)',
                                transform: 'scaleX(-1)',
                                borderRadius: '30px',
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <h2>ADHD Testing</h2>
                        <p className="text-secondary" style={{ fontSize: 18 }}>
                            If you are struggling with your work, school or relationships due to
                            inability to keep your attention, focus, or restlessness under
                            control, you may have a neurological disorder. While other clinics
                            may immediately recommend stimulant medications or other treatments,
                            Redemption Psychiatry is committed to excellence and prioritizes
                            ensuring the best possible understanding before moving on to
                            treatment.
                        </p>
                    </div>
                </div>

                {/* How it Works */}
                <div className="row align-items-center">
                    <div className="col-md-12">
                        <h2> How it Works </h2>
                        <p>
                            Redemption Psychiatry partners with Creyos, a testing system designed
                            to analyze your unique brain and deliver valuable insights to your
                            provider. This is done by administering a series of interactive,
                            game-like tests which collect information on your reaction times,
                            tendency towards error, spatial reasoning under pressure, etc. This
                            information is compiled into a report to allow your provider to
                            understand your unique struggles and abilities, leading to more
                            accurate diagnoses, more effective care, and a better you.
                        </p>
                    </div>
                </div>

                {/* Commitment to Repeat Testing */}
                <div className="row align-items-center mb-5">
                    <div className="col-md-12">
                        <h2 className="text-end"> A Commitment to Repeat Testing </h2>
                        <p>
                            Redemption Psychiatry commits to repeat-testing its patients for a
                            variety of reasons. Research shows that as little as 15% of children
                            diagnosed with ADHD still have full-fledged ADHD at age 25, while
                            approximately 65% have partial symptoms (Faraone, Biederman, & Mick,
                            2006). This demonstrates that symptoms change over time. By retesting
                            intermittently, providers can determine if medications are helping
                            and if the underlying disorder is improving or worsening, allowing
                            them to tailor treatment for the best outcome.
                        </p>
                    </div>
                </div>

                {/* Costs and Coverage */}
                <div className="row align-items-start mb-5">
                    <div className="col-12">
                        <h2>Costs and Coverage</h2>
                        <p>
                            Neurological testing is covered by almost all major insurance
                            carriers, meaning what most patients pay is determined by their
                            specific plan. Some patients may need a prior authorization, while
                            many do not. To make testing as affordable as possible, Redemption
                            Psychiatry offers testing to those not covered for $150, with
                            additional discounts to those who qualify!
                        </p>
                    </div>

                    <div className="col-12">
                        <div className="d-flex justify-content-between flex-wrap gap-3">
                            <a
                                href="/newpatients"
                                className="button blue flex-fill text-center"
                                style={{ minWidth: 0 }}
                            >
                                Schedule a Full Diagnostic Interview
                            </a>
                        </div>
                    </div>
                </div>

                {/* FAQ */}
                <div className="row align-items-center mb-5">
                    <div className="col-md-12">
                        <h2 className="text-center"> FAQ </h2>
                        <div className="text-secondary" style={{ fontSize: 18, lineHeight: 1.6 }}>
                            <p>
                                <strong>How Long Does Testing Take?</strong> For your testing
                                appointment, you should expect to spend approximately 20 minutes
                                testing. Including check-in, setup, and debrief, expect to be at
                                our clinic for 40 minutes total. This does not include your intake
                                or follow-up with your provider, which are separate appointments
                                (60 minutes and 20 minutes respectively).
                            </p>
                            <p>
                                <strong>Can I see my provider the same day?</strong> Sometimes—some
                                insurances won't cover multiple appointments on the same day. If your insurance will not cover, we offer highly competitive cash pay rates as well as multiple offices to complete your testing at, so you can get it done on your terms.
                            </p>
                            <p>
                                <strong>Are the testing results a diagnosis?</strong> No. Only a
                                trained provider can diagnose. The testing provides data to help
                                them make an informed diagnosis, similar to how lab work supports
                                medical decisions.
                            </p>
                            <p>
                                <strong>What are the age ranges?</strong> Testing can be
                                completed by anyone ages 6 and up.
                            </p>
                            <p>
                                <strong>How should I prepare?</strong> Avoid caffeine, marijuana,
                                and other substances that might unnaturally affect your
                                concentration. Get a good night's sleep and confirm with your
                                provider which medications to take the day of testing.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Widgets */}
                <Widgets />
            </div>
        </div>
        <Footer />
    </>
);

export default NeurologicalTesting;
